import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import { can_move_selected_objects } from '../../lattice';
import BarButton from '@components/bar-button';
import { shift_pressed } from '../../keypress';
import move_svg from '../../../assets/img/SVG_icons/Top/editing_model/rigid_move.svg';
import { img } from '@phi/components';
import { uid_hide_rigid_move_manipulator, uid_show_rigid_move_manipulator } from '@frontend/ui_display';
import MoveTooltip from './MoveTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const MoveIcon = move_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Rigid move or free scale';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_edge_tangent_mode
                || !this.can_move;
        },

        total_selected_objects() {
            return this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
        },

        can_move() {
            if (this.total_selected_objects === 0)
                return false;
            else
                return can_move_selected_objects();
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.rigid_move_manipulator)
                uid_hide_rigid_move_manipulator(false, 0, true);
            else
                uid_show_rigid_move_manipulator(false, 0, true, false, false, false, shift_pressed(), false);
        },
    },

    render() {
        return h(BarButton, {
            id: 'rigid-move-button',
            wrapperId: 'rigid-move-wrapper',
            active: this.state.rigid_move_manipulator,
            selected: this.state.tut_stage === 5,
            disabled: this.disabled,
            onClick: this.onClick,
            tippy: 'bottom',
            help: 'rigid_move',
        }, {
            label: () => 'Move',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(move_svg, this.alt),
            tooltip: MoveTooltip,
        });
    },
});
